import { TypeChecker } from '@attain-apps/type-guards'

export interface Unit {
  readonly parentId?: string
  readonly id: string
  readonly code: string
  readonly name: string
  readonly description?: string
}
export namespace Unit {
  export const isUnit = TypeChecker.Factory.object<Unit>({
    code: TypeChecker.isString,
    description: TypeChecker.Factory.optional(TypeChecker.isString),
    id: TypeChecker.isString,
    name: TypeChecker.isString,
    parentId: TypeChecker.Factory.optional(TypeChecker.isString),
  })
}
